// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"1":"d40ddf80","787":"5b557567","851":"56bba7f2"}[chunkId] + ".chunk.js";
};